import { render, staticRenderFns } from "./TripMessages.vue?vue&type=template&id=c2ed8aa6&lang=html&"
import script from "./TripMessages.vue?vue&type=script&lang=js&"
export * from "./TripMessages.vue?vue&type=script&lang=js&"
import style0 from "./TripMessages.vue?vue&type=style&index=0&id=c2ed8aa6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports